import { update } from '@wix/ambassador-siteproperties-v4-properties/http';
export const updateSiteLanguage = async (httpClient, errorHandler, language) => {
  const {
    data
  } = await errorHandler.withErrorHandler(() => httpClient.request(update({
    fields: ['language'],
    properties: {
      language
    }
  })), {
    errorCodesMap: {
      applicationError: {
        ILLEGAL_ARGUMENT: false,
        META_SITE_NOT_FOUND: false,
        PERMISSION_DENIED: false,
        RATE_LIMIT_EXCEEDED: false
      }
    }
  });
  return data;
};
//# sourceMappingURL=update-site-language.js.map